<automata-start-manual-automation-form
  [title]="'AUTOMATIONS.MANUAL_AUTOMATIONS.SELECT_TITLE_V2' | translate"
  [entities]="entities"
  [companyName]="companyName"
  [partnerId]="partnerId"
  [marketIds]="marketIds"
  [warnings]="warnings"
  [hideSettingsLink]="hideSettingsLink"
  [onlySalespersonAutomations]="onlySalespersonAutomations"
  [entityType]="entityType"
  [onlySelectDontStart]="onlySelectDontStart"
  [isListOfEntities]="isListOfEntities"
  [context]="context"
  (cancel)="close()"
  (success)="close($event)"
></automata-start-manual-automation-form>
